/** UTC calendar month boundary — keep in sync with backend/utils/planTier.js */
export const isNewUtcMonth = (now, resetDate) => {
  if (!resetDate) return true;
  return (
    now.getUTCFullYear() !== resetDate.getUTCFullYear() ||
    now.getUTCMonth() !== resetDate.getUTCMonth()
  );
};

export const getDetectedTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
};
